import { useState } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import CollapsibleCard from "../CollapsibleCard";
import stringToReactNodesWithLinks from "./stringToReactNodesWithLinks";

const LockNote = ({
  lockNote,
  setSite,
}: {
  lockNote: string;
  setSite: (update) => void;
}) => {
  const [renderEnabled, setRenderEnabled] = useState(true);
  return (
    <CollapsibleCard
      title={"Lock note"}
      className="mb-3"
      menu={
        <Form.Group controlId="debugCheck">
          <Form.Check
            type="switch"
            label="Render"
            checked={renderEnabled}
            onChange={(e) => setRenderEnabled(e.target.checked)}
          />
        </Form.Group>
      }
    >
      <Row>
        <Col>
          {renderEnabled && (
            <div
              style={{
                whiteSpace: "pre-wrap",
                overflowWrap: "anywhere",
                wordBreak: "normal",
              }}
              data-testid="site-lockNote-rendered"
            >
              {stringToReactNodesWithLinks(lockNote)}
            </div>
          )}
          {!renderEnabled && (
            <Form.Group className="mb-3" controlId="lockNote">
              <Form.Control
                as="textarea"
                rows={10}
                value={lockNote}
                onChange={(e) => setSite({ lockNote: e.target.value })}
                data-testid="site-lockNote"
              />
            </Form.Group>
          )}
        </Col>
      </Row>
    </CollapsibleCard>
  );
};

export default LockNote;
